import { render, staticRenderFns } from "./InfoPubCoop.vue?vue&type=template&id=5349f5dc&scoped=true"
import script from "./InfoPubCoop.vue?vue&type=script&lang=js"
export * from "./InfoPubCoop.vue?vue&type=script&lang=js"
import style0 from "./InfoPubCoop.vue?vue&type=style&index=0&id=5349f5dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349f5dc",
  null
  
)

export default component.exports